import { BrandfolderHexColors } from '../enums/colors.js';

const defaultListLight = {
    backgroundColor: BrandfolderHexColors.White,
    borderColor: 'transparent'
};
const defaultListPrimary = {
    backgroundColor: BrandfolderHexColors.PurplePopsicle,
    borderColor: 'transparent'
};

export { defaultListLight, defaultListPrimary };
//# sourceMappingURL=list.js.map
